import { defineMessages } from 'react-intl'

const scope = `procurify.components.SettingsImportRows`

export default defineMessages({
  importCSVFile: {
    id: `${scope}.importCSVFile`,
    defaultMessage: 'Import CSV File',
  },
  downloadTemplate: {
    id: `${scope}.downloadTemplate`,
    defaultMessage: 'Download template',
  },
  learnMore: {
    id: `${scope}.learnMore`,
    defaultMessage: 'Learn more',
  },
})
